import React, { Component } from 'react';
import './Sidebar.css';
/*
 * Sidebar.js
 *
 * This module contains 2 widgets. These are exported in SidebarComponents,
 * the default, and only export.
 *
 *      SidebarComponents.TagList
 *      SidebarComponents.CategoryTreeFL
 *
 * # TagList:
 *
 * Taglist offers a tag cloud for the sidebar. Tags are colorized based on the
 * number of posts attached.
 *
 * # CategoryTreeFL
 *
 * The cateogry tree is a complex structure.
 * This widget shows the list of categories at the bottom level of the tree.
 */

import { TagListWidget, CategoryListWidget } from './Widgets';

function mostPosts(accumulator, aPost) {
  if (aPost.post_count > accumulator) {
    return aPost.post_count;
  }
  return accumulator;
}

/*
 * ToggleCloud - provide a cloud that can turn into a menu for mobile.
 *
 * Strategy:
 *
 * 1. Use a hidden checkbox, with a lable immediately before the element that
 *    will be shown/hidden.
 * 2. Use a label on the element set with an htmlFor="id of the checkbox".
 *    This means we don't need to toggle the checkbox on, the browser does
 *    that automatically.
 * 3. Provide <input onClick={this.onToggle}/> - for some reason this is required to
 *    make the label work in chrome, at least.
 * 4. Provide <div onClick={this.turnOff}/> to hide the element when any item
 *    is clicked.
 *
 * Example Component:
 *
 *     <h3><label htmlFor="TOGGLE">Tags</label></h3>
 *     <input onClick={this.onToggle} type="checkbox" id="TOGGLE" checked={this.state.show?true:false}/>
 *     <div className="HIDEME" onClick={this.turnOff}>HIDE ME!</div>
 *
 * Css:
 *
 * #TOGGLE { display: none}
 * @media all and (max-width:  none }
 *    .div.HIDEME { display: none }
 *    [id=^TOGGLE]:checked+div.HIDEME { display: block }
 * }
 * 
 *
 */
class ToggleCloud extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleCloudShow: false,
    };
    this.onToggle = this.onToggle.bind(this);
    this.turnOff = this.turnOff.bind(this);
  }
  turnOff() {
    // Set the show flag off.
    if (this.state.toggleCloudShow) {
      this.setState({toggleCloudShow: false});
    }
  }
  onToggle() {
    // toggle the show flag.
    this.setState({toggleCloudShow: !this.state.toggleCloudShow});
  }
  get isVisible() {
    return this.state.toggleCloudShow?true:false;
  }
}

// use CSS to show/hide things when appropriate using '[id=checkbox-id]+div.things-to-toggle' 
// use react to set the value of the checkbox.
class TagList extends ToggleCloud {
  render() {
    var maxCount = 0;
    if (this.props.tagList.length > 0) {
      maxCount = this.props.tagList.list.reduce(mostPosts, 0);
    }
    return <div className="Tag-cloud">
      <h3><label htmlFor="Tag-drop">Tags</label></h3>
      <input onClick={this.onToggle} type="checkbox" id="Tag-drop" checked={this.isVisible}/>
      <div className="Sidebar-toggle" onClick={this.turnOff}>
      <nav>
      { this.props.tagList.length && <TagListWidget colorizeMax={maxCount} getTag={this.props.getTag} tags={this.props.tagList.list.filter(item => item.post_count > 2)} /> }
      </nav>
      </div>
    </div>
  }
}

class CategoryTreeFL extends ToggleCloud {
  render() {
    var categories = [];
    // get the top level categories.
    for (var key in this.props.categoryTree.tree) {
      categories.push(this.props.categoryTree.categories[key])
    }
    return <div className="Tag-cloud">
      <h3><label htmlFor="Category-drop">Root Categories</label></h3>
      <input onClick={this.onToggle} type="checkbox" id="Category-drop" checked={this.isVisible}/>
      <div className="Sidebar-toggle" onClick={this.turnOff}>
      <nav>
      { this.props.categoryTree.categories && <CategoryListWidget inline={true} getCategory={this.props.getCategory} categories={categories} /> }
      </nav>
      </div>
    </div>
  }
}

// New category tree.
// - Show the category box as in CategoryTreeeFL
// - Add hamburger icon to each category that has subcategories.
// - Clicking the hamburger renders a new box below containing subcategories for the selected category.
// - The hamburger for the selected category is flipped 90 degrees.
// - Each subcategory follows the same rules as each may have its own subcategories.


const SidebarComponents = {
    TagList: TagList,
    CategoryTreeFL: CategoryTreeFL,
}
export default SidebarComponents;


// WEBPACK FOOTER //
// ./src/Components/Sidebar.js